import { render, staticRenderFns } from "./CompetitorPage.vue?vue&type=template&id=824c3612&scoped=true&"
import script from "./CompetitorPage.vue?vue&type=script&lang=js&"
export * from "./CompetitorPage.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorPage.vue?vue&type=style&index=0&id=824c3612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824c3612",
  null
  
)

export default component.exports